import { useState } from 'react';

import s from './AnalysisTables.module.scss';

const CONSTRAINT_STATUS_LABEL = {
    ok: 'Соответствует',
    violated: 'Нарушено',
    unknown: 'Нет данных',
};

const COMPETENCY_STATUS_LABEL = {
    ok: 'Соответствует',
    partial: 'Частично',
    missing: 'Не соответствует',
};


export function CompetencyTable({ items }) {
    // Раскрытые цитаты. Оценки, сделанные до появления поля evidence, значка
    // не получают - строка выглядит ровно как раньше.
    const [opened, setOpened] = useState({});

    if (!items || items.length === 0) return null;

    const toggle = (idx) => setOpened(prev => ({ ...prev, [idx]: !prev[idx] }));

    return (
        <section className={s.block}>
            <h3 className={s.title}>Оценка по компетенциям</h3>
            <div className={s.table}>
                <div className={`${s.row} ${s.headRow}`}>
                    <div className={s.colName}>Компетенция</div>
                    <div className={s.colStatus}>Статус</div>
                    <div className={s.colComment}>Комментарий</div>
                </div>
                {items.map((item, idx) => {
                    const evidence = item.evidence;
                    const isOpen = Boolean(opened[idx]);
                    return (
                        <div key={idx} className={s.rowGroup}>
                            <div
                                className={`${s.row} ${evidence ? s.rowClickable : ''}`}
                                onClick={evidence ? () => toggle(idx) : undefined}
                            >
                                <div className={s.colName}>{item.name}</div>
                                <div className={s.colStatus}>
                                    <span className={`${s.statusChip} ${s[item.status || 'missing']}`}>
                                        {COMPETENCY_STATUS_LABEL[item.status] || '—'}
                                    </span>
                                    {evidence && (
                                        // Клик ловит вся строка, значок - только подсказка,
                                        // что подтверждение есть и его можно раскрыть.
                                        <span className={s.evidenceMark}>
                                            <span aria-hidden="true">”</span>
                                            <span className={`${s.tooltip} ${s.evidenceTooltip}`}>
                                                <span className={s.tooltipTitle}>Подтверждение из опыта</span>
                                                <span className={s.tooltipValue}>{evidence}</span>
                                            </span>
                                        </span>
                                    )}
                                </div>
                                <div className={s.colComment}>{item.comment || '—'}</div>
                            </div>
                            {evidence && isOpen && (
                                <div className={s.evidenceBox}>
                                    <span className={s.evidenceLabel}>Из опыта работы</span>
                                    <q className={s.evidenceText}>{evidence}</q>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}


export function QuestionsTable({ items }) {
    if (!items || items.length === 0) return (
        <section className={s.block}>
            <h3 className={s.title}>Вопросы для уточнения</h3>
            <div className={s.table}>
                <div className={s.questionRow} style={{color: '#94a3b8'}}>Вопросов для уточнения нет</div>
            </div>
        </section>
    );
    return (
        <section className={s.block}>
            <h3 className={s.title}>Вопросы для уточнения</h3>
            <div className={s.table}>
                {items.map((question, idx) => (
                    <div key={idx} className={s.questionRow}>
                        <span className={s.questionNum}>{idx + 1}</span>
                        <span>{question}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}


export function ConstraintTable({ items }) {
    if (!items || items.length === 0) return null;
    return (
        <section className={s.block}>
            <h3 className={s.title}>Проверка ограничений</h3>
            <div className={s.table}>
                <div className={`${s.row} ${s.headRow}`}>
                    <div className={s.colName}>Ограничение</div>
                    <div className={s.colStatus}>Статус</div>
                    <div className={s.colComment}>Комментарий</div>
                </div>
                {items.map((item, idx) => (
                    <div key={idx} className={s.row}>
                        <div className={s.colName}>{item.name}</div>
                        <div className={s.colStatus}>
                            <span className={`${s.statusChip} ${s[item.status || 'unknown']}`}>
                                {CONSTRAINT_STATUS_LABEL[item.status] || '—'}
                            </span>
                        </div>
                        <div className={s.colComment}>{item.comment || '—'}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}